import React from 'react';
import { useStateHandler } from './use-state-handler';

/**
 * @type {React.Context<ReturnType<typeof useStateHandler>>}
 */
const SimuladorEnergiaSolarContext = React.createContext();

export function SimuladorStateProvider({ children }) {
  const state = useStateHandler();

  return (
    <SimuladorEnergiaSolarContext.Provider value={state}>
      {children}
    </SimuladorEnergiaSolarContext.Provider>
  );
}

export function useSimuladorEnergiaSolarState() {
  const context = React.useContext(SimuladorEnergiaSolarContext);
  return context;
}
